import {
  NotificationPlacement,
  NotificationContext,
  NotificationType,
} from "./types";

let api: any;

export const setNotificationAPI = (notificationAPI: any) => {
  api = notificationAPI;
};

export const openNotification = (
  placement: NotificationPlacement,
  title: string,
  message: string,
  status: NotificationType
) => {
  if (!api) {
    console.warn("Notification API is not initialized.");
    return;
  }

  api[status]({
    message: title,
    description: (
      <NotificationContext.Consumer>
        {() => message}
      </NotificationContext.Consumer>
    ),
    placement,
  });
};
